import React from "react"
import PropTypes from "prop-types"
import { useAppContext } from "@components/AppContext"
import { QuestionCircleOutlined } from "@ant-design/icons"
import { Space, Tooltip, Typography } from "antd"

import ListInput from "@components/Form/Input/ListInput"
import { FormShape } from "@components/Form"
import { TIER_NAMES } from "@components/Domain"
import { TYPE_STRING, TYPE_CHECKBOX, TYPE_NUMBER } from "@components/Form/FormItem/types"

const LABEL_NAME = "Name"
const LABEL_INTERNAL = "Internal"
const LABEL_DESCRIPTION = "Description"
const LABEL_INTERNAL_TOOLTIP = "Internal classes are not visible to investors in the soft commitment form."


const TiersListInput = ({
  form,
  name,
  path,
  title,
  addTitle
}) => {
  const { isAccountant } = useAppContext()

  const max = TIER_NAMES.length
  const onlyLastDelete = true

  const canEditReturnPercentage = isAccountant

  const schema = [
    {
      name: "title",
      type: TYPE_STRING,
      required: true,
      maxLength: 64,
      itemProps: { noStyle: true },
      inputProps: { style: { width: "25%" }},
      placeholder: LABEL_NAME,
    },
    {
      name: "returnPercentage",
      type: TYPE_NUMBER,
      itemProps: { noStyle: true },
      inputProps: {
        style: { width: "15%" },
        parser: (value) => value?.replace('%', ''),
        formatter: (value) => `${value}%`,
        min: "0",
        step: "0.1",
        disabled: !canEditReturnPercentage,
      },
    },
    {
      name: "description",
      type: TYPE_STRING,
      required: true,
      maxLength: 256,
      itemProps: { noStyle: true },
      inputProps: { style: { width: "65%" } },
      placeholder: LABEL_DESCRIPTION,
    },
    {
      name: "isPrivate",
      type: TYPE_CHECKBOX,
      required: false,
      itemProps: { noStyle: true },
      inputProps: {
        style: { marginTop: 6 },
        label: (
          <Space>
            {LABEL_INTERNAL}
            <Tooltip title={LABEL_INTERNAL_TOOLTIP}>
              <Typography.Text type="secondary">
                <QuestionCircleOutlined />
              </Typography.Text>
            </Tooltip>
          </Space>
        ),
      }
    }
  ]

  const listInputProps = {
    min: 1,
    className: "horizontal-oriented",
    max,
    form,
    name,
    path,
    title,
    schema,
    addTitle,
    onlyLastDelete
  }

  return (
    <div style={{ marginBottom: 24 }}>
      <ListInput {...listInputProps} />
    </div>
  )
}

TiersListInput.propTypes = {
  form: FormShape.isRequired,
  name: PropTypes.arrayOf(PropTypes.string).isRequired,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  addTitle: PropTypes.string.isRequired,
}

export default TiersListInput
